import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import SignupDetailsModal from "../components/admin/SignupDetailsModal";
import DashboardHeader from "../components/admin/DashboardHeader";
import DashboardStats from "../components/admin/DashboardStats";
import SignupTable from "../components/admin/SignupTable";
import PageTitle from "../components/PageTitle";
import EnquiriesTable from "../components/admin/EnquiriesTable";
import ServiceEnquiriesTable from "../components/admin/ServiceEnquiriesTable";
import JobApplicationsTable from "../components/admin/JobApplicationsTable";

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("signups");
  const navigate = useNavigate();
const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSignup, setSelectedSignup] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
const [serviceFilter, setServiceFilter] = useState("All");
const [statusFilter, setStatusFilter] = useState("All");

const filteredRecords = signups.filter((signup) => {
  const search = searchTerm.toLowerCase();

  const matchesSearch =
    (signup.name || "").toLowerCase().includes(search) ||
    (signup.phone || "").toLowerCase().includes(search) ||
    (signup.email || "").toLowerCase().includes(search);

  const matchesService =
    serviceFilter === "All" ||
    signup.service === serviceFilter;

  const currentStatus = signup.status || "New";

  const matchesStatus =
    statusFilter === "All" ||
    currentStatus === statusFilter;

  return matchesSearch && matchesService && matchesStatus;
});
const collectionName =
  activeTab === "signups"
    ? "signups"
    : activeTab === "contacts"
    ? "contactEnquiries"
    : activeTab === "waiting"
    ? "notifySubscribers"
    : activeTab === "serviceEnquiries"
    ? "enquiries"
    : activeTab === "jobApplications"
    ? "jobApplications"
    : "signups";
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/admin-login");
        return;
      }

      try {
      const snapshot = await getDocs(collection(db, collectionName));

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSignups(data);
      } catch (error) {
        console.error("Error loading signups:", error);
      } finally {
        setLoading(false);
      }
    });
console.log("selectedSignup:", selectedSignup);

    return () => unsubscribe();
  }, [activeTab, collectionName, navigate]);
const handleStatusChange = async (signupId, newStatus) => {
  try {
   const signupRef = doc(db, collectionName, signupId);

    await updateDoc(signupRef, {
      status: newStatus,
    });

    setSignups((currentSignups) =>
      currentSignups.map((signup) =>
        signup.id === signupId
          ? { ...signup, status: newStatus }
          : signup
      )
    );

    if (selectedSignup?.id === signupId) {
      setSelectedSignup((current) => ({
        ...current,
        status: newStatus,
      }));
    }
 } catch (error) {
  console.error("Error updating status:", error);
  console.error("Error Code:", error.code);
  console.error("Error Message:", error.message);

  alert(error.message);
}
};
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/admin-login");
  };

  return (
    <>
    <PageTitle title="Admin Dashboard | Anara Lifethread" />
   
    <main className="min-h-screen bg-ivory-100 pt-28 pb-20">
      <div className="max-w-7xl mx-auto px-6">
       <DashboardHeader
  activeTab={activeTab}
  setActiveTab={setActiveTab}
  handleLogout={handleLogout}
/>

<DashboardStats
  signups={signups}
  activeTab={activeTab}
/> 


<div className="bg-white rounded-3xl border border-sage-100 shadow-soft overflow-hidden">

          {loading ? (
            <div className="p-10 text-center text-ink-muted">
              Loading enquiries...
            </div>
          ) : signups.length === 0 ? (
            <div className="p-10 text-center text-ink-muted">
              No enquiries found.
            </div>
          ) : (
            <div className="overflow-x-auto">
{activeTab === "signups" && (
  <SignupTable
    records={signups}
    filteredRecords={filteredRecords}
    searchTerm={searchTerm}
    setSearchTerm={setSearchTerm}
    serviceFilter={serviceFilter}
    setServiceFilter={setServiceFilter}
    statusFilter={statusFilter}
    setStatusFilter={setStatusFilter}
    handleStatusChange={handleStatusChange}
    setSelectedSignup={setSelectedSignup}
  />
)} 
{activeTab === "contacts" && (
  <table className="w-full text-left">
    <thead className="bg-sage-50">
      <tr>
        <th className="px-6 py-4">Name</th>
        <th className="px-6 py-4">Phone</th>
        <th className="px-6 py-4">Email</th>
        <th className="px-6 py-4">Service</th>
        <th className="px-6 py-4">Status</th>
        <th className="px-6 py-4">Action</th>
      </tr>
    </thead>

    <tbody>
      {signups.map((contact) => (
        <tr
          key={contact.id}
          className="border-t border-sage-100"
        >
          <td className="px-6 py-4">{contact.name || "-"}</td>
          <td className="px-6 py-4">{contact.phone || "-"}</td>
          <td className="px-6 py-4">{contact.email || "-"}</td>
          <td className="px-6 py-4">{contact.service || "-"}</td>

          <td className="px-6 py-4">
            <span className="px-3 py-1 rounded-full bg-sage-100 text-sage-700 text-sm">
              {contact.status || "New"}
            </span>
          </td>

          <td className="px-6 py-4">
            <button
              onClick={() => setSelectedSignup(contact)}
              className="text-sage-700 hover:underline"
            >
              View
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
)}
{activeTab === "waiting" && (
  <table className="w-full text-left">
    <thead className="bg-sage-50">
      <tr>
        <th className="px-6 py-4">Email</th>
        <th className="px-6 py-4">Platform</th>
        <th className="px-6 py-4">Status</th>
        <th className="px-6 py-4">Date</th>
      </tr>
    </thead>

    <tbody>
      {signups.map((user) => (
        <tr
          key={user.id}
          className="border-t border-sage-100"
        >
          <td className="px-6 py-4">{user.email}</td>

          <td className="px-6 py-4">
            {user.platform || "-"}
          </td>

          <td className="px-6 py-4">
            <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-sm">
              {user.status}
            </span>
          </td>

          <td className="px-6 py-4">
            {user.createdAt?.toDate
              ? user.createdAt.toDate().toLocaleDateString()
              : "-"}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  
)}
{activeTab === "serviceEnquiries" && (
  <ServiceEnquiriesTable
    records={signups}
    filteredRecords={filteredRecords}
    searchTerm={searchTerm}
    setSearchTerm={setSearchTerm}
    serviceFilter={serviceFilter}
    setServiceFilter={setServiceFilter}
    statusFilter={statusFilter}
    setStatusFilter={setStatusFilter}
    handleStatusChange={handleStatusChange}
    setSelectedEnquiry={setSelectedSignup}
  />
)}
{activeTab === "jobApplications" && (
  <JobApplicationsTable
    records={signups}
    setSelectedSignup={setSelectedSignup}
  />
)}

            </div>
          )}

        </div>
      </div>
 <SignupDetailsModal
  selectedSignup={selectedSignup}
  setSelectedSignup={setSelectedSignup}
/>

    </main>
 </>
  );
  
}